import { decode } from 'html-entities';
import { B2BRestQueueMessage } from 'api/resources/models/AutoGenerated';

export const valuesConverter = (data: B2BRestQueueMessage[]) => {
  return data.map((row) => {
    return {
      ...row,
      messageContent: decode(decode(row.messageContent, { level: 'xml' }), {
        level: 'xml',
      }),
    };
  });
};
